module.exports = __webpack_public_path__ + "static/img/icon-10.764dfbb1.png";